import { IPreflight } from '@cbgms/api/modules/root'
import * as types from './types'

export const setEnvironment = (data: IPreflight) => ({
  type: types.SET_ENVIRONMENT_VARIABLES,
  payload: data
})
